import { Track } from "@/src/lib/tracking";
import { getBridge, waitForAppFeatures } from "@/src/lib/bridge";

export type DelegateNativeChatParams = {
  question?: string;
  autoSubmit?: boolean;
  autoRenew?: boolean;
};

/**
 * App 内且 `features.nativeChat === true` 时发 `open-native-chat`。
 * 浏览器 / 老 App / 桥失败 → `false`，调用方继续走 H5 Chat。
 */
export async function tryDelegateToNativeChat(
  params: DelegateNativeChatParams,
): Promise<boolean> {
  let inApp = false;
  try {
    inApp = getBridge().isInApp();
  } catch {
    return false;
  }
  if (!inApp) {
    return false;
  }

  const features = await waitForAppFeatures();
  if (features?.nativeChat !== true) {
    return false;
  }

  try {
    getBridge().openNativeChat({
      question: params.question ?? "",
      autoSubmit: params.autoSubmit,
      autoRenew: params.autoRenew,
    });
    return true;
  } catch (e) {
    Track.log("warn", "NativeChat", "native chat delegate failed", {
      cause: String(e),
    });
    return false;
  }
}
